import React from "react";
import styles from "./FormatCert.module.scss";
import LeftColoredTitle from "../../../components/Titles/LeftColoredTitle";
import FormationCard from "../../../components/Cards/FormationCard/FormationCard";

import { formations as fake_data } from "../../../assets/data/Formations";

function FormatCert() {
  return (
    <div className={styles.main}>
      <LeftColoredTitle>FORMATIONS CERTIFIANTES</LeftColoredTitle>

      <div className={styles.formats}>
        {fake_data.map((format, key) => {
          return (
            <div key={key} className={styles.format_cont}>
              <FormationCard format={format} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FormatCert;
